import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dropdown } from 'primereact/dropdown';
import 'primeicons/primeicons.css';
import Alertas from "../../alertas";

function DadosAutorViolencia({ setFraseTopo, setStage, parentescoAutor, setParentescoAutor, nomeAutor, dataNascAutor, cpfAutor, telefoneAutor, emailAutor, cepCasaAutor, ruaCasaAutor, numeroCasaAutor, compCasaAutor, file_rg_autor, setNomeAutor, setDataNascAutor, setCpfAutor, setTelefoneAutor, setEmailAutor,  setCepCasaAutor, setRuaCasaAutor, setNumeroCasaAutor, setCompCasaAutor, setFile_rg_autor }) {

    const graus = [
        { name: 'Cônjujes'},
        { name: 'Parceiro/parceira'},
        { name: 'Vizinhos'},
        { name: 'Colegas/conhecidos'},
        { name: 'Cunhados'},
        { name: 'Sogro/sogra'},
        { name: 'Pai/mãe'},
        { name: 'Filho/filha'},
        { name: 'Avô/avó'},
        { name: 'Neto/neta'},
        { name: 'Irmão/irmã'},
        { name: 'Tios/tia'},
        { name: 'Sobrinho/sobrinha'},
        { name: 'Primo/prima'}
    ];

    function changeFiles(file) {
        const maxSize = 3 * 1024 * 1024; // 3 MB em bytes
        if (file.size > maxSize) {
            Alertas.atencao('Tamanho não permitido. Por favor escolha um arquivo de no máximo 3 MB.');
        } else {
            setFile_rg_autor(file);
        }
    }

    useEffect(() => {
        setFraseTopo("Você merece viver em paz.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="app-main-mulher">
            <h3 className="main-titulo-mulher">DADOS DO AUTOR DA VIOLÊNCIA</h3>
            <span className="main-text-mulher">Preencha com o máximo de informações que tiver sobre o autor da agressão</span>
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels">Grau de Parentesco </p>
                        <Dropdown value={parentescoAutor} onChange={(e) => setParentescoAutor(e.value)} options={graus} optionLabel="name"
                            placeholder="SELECIONE"/>

                    </div>
                </div>

            </div>
            <div className="main-card-mulher">

                <div className="card-form card-form-mulher">
                    <div className="card-form-b">
                        <p className="labels">CPF </p>
                        <InputMask mask="999.999.999-99" value={cpfAutor} onChange={(e) => setCpfAutor(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Nome Completo </p>
                        <InputText value={nomeAutor} onChange={(e) => setNomeAutor(e.target.value)} />
                    </div>
                    <div className="card-form-b">
                        <p className="labels">Data de Nascimento</p>
                        <InputMask mask="99/99/9999" value={dataNascAutor} onChange={(e) => setDataNascAutor(e.target.value)} />
                    </div>
                </div>
                <div className="card-form card-form-mulher">
                    <div className="card-form-b">
                        <p className="labels">CEP </p>
                        <InputText value={cepCasaAutor} onChange={(e) => setCepCasaAutor(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Rua </p>
                        <InputText value={ruaCasaAutor} onChange={(e) => setRuaCasaAutor(e.target.value)} />
                    </div>
                    <div className="card-form-b">
                        <p className="labels">Número </p>
                        <InputText value={numeroCasaAutor} onChange={(e) => setNumeroCasaAutor(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Complemento </p>
                        <InputText value={compCasaAutor} onChange={(e) => setCompCasaAutor(e.target.value)} />
                    </div>
                </div>
            </div>

            <h3 className="main-titulo-mulher">INFORMAÇÕES DE CONTATO DO AUTOR DA VIOLÊNCIA</h3>
            <span className="main-text-mulher">Preencha com o máximo de informações que tiver sobre o autor da agressão</span>
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div className="card-form-a">
                        <p className="labels">Telefone </p>
                        <InputMask mask="(99) 99999-9999" value={telefoneAutor} onChange={(e) => setTelefoneAutor(e.target.value)} />
                    </div>
                    <div className="card-form-a">
                        <p className="labels">Email </p>
                        <InputText value={emailAutor} onChange={(e) => setEmailAutor(e.target.value)} />
                    </div>
                </div>

            </div>

            <h3 className="main-titulo-mulher">DOCUMENTO DO AUTOR DA VIOLÊNCIA</h3>
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <span className='input-arquivo-mulher'>
                        <label className='label-file'
                            style={file_rg_autor ? { backgroundColor: "#30053F" } : { backgroundColor: "#571070" }}
                        >
                            {file_rg_autor ?
                                <span className='file-name'> <i className="pi pi-image" ></i>{" "} {file_rg_autor.name} </span>
                                :
                                <span className='file-name'>Nenhum arquivo selecionado<i className="pi pi-upload"></i>{" "}</span>
                            }
                            <input
                                type="file"
                                className='input-files'
                                accept='image/*'
                                onChange={e => changeFiles(e.target.files[0])}
                            />
                        </label>
                    </span>
                </div>
            </div>
            <div className="card-rodape-mulher">
                <Button
                    label="Voltar"
                    className="btn-1-mulher"
                    onClick={() => setStage(1)}
                />
                <Button
                    style={{ marginLeft: "10px" }}
                    label="Próximo"
                    className="btn-1-mulher"
                    onClick={() => setStage(3)}
                />
            </div>
        </div>

    );
}

export default DadosAutorViolencia;
